<template>
  <div class="room-doc-share-palette-component">
    <div class="room-doc-share-palette">
      <ul class="room-doc-share-palette-list">
        <li class="room-doc-share-palette-item">
          <div class="room-doc-share-palette-button-wrapper">
            <button class="room-doc-share-palette-button laser-pointer" :class="{ selected : selectedTab == 'LaserPointer' }"
                    v-tooltip.bottom="$t('doc.palette.lazer')" @click.prevent="useLaserPointer">
            </button>
          </div>
        </li>
        <li class="room-doc-share-palette-item">
          <div class="room-doc-share-palette-button-wrapper">
            <button class="room-doc-share-palette-button pencil" :class="{ selected : selectedTab == 'Pencil' }"
                    v-tooltip.bottom="$t('doc.palette.pen')" @click.prevent="usePencil">
            </button>
          </div>
        </li>
        <li class="room-doc-share-palette-item">
          <div class="room-doc-share-palette-button-wrapper">
            <button class="room-doc-share-palette-button highlighter" :class="{ selected : selectedTab == 'Highlighter' }"
                    v-tooltip.bottom="$t('doc.palette.highlighter')" @click.prevent="useHighlighter">
            </button>
          </div>
        </li>
        <li class="room-doc-share-palette-item">
          <div class="room-doc-share-palette-button-wrapper">
            <button class="room-doc-share-palette-button figures" :class="{ selected : figureList.includes(selectedTab) }"
                    v-tooltip.bottom="$t('doc.palette.figures')">
            </button>
          </div>
          <ul class="room-doc-share-palette-sub-list">
            <li v-for="(figure, i) in figureList"
                :key="i"
                class="room-doc-share-palette-sub-item"
            >
              <button :class="['room-doc-share-palette-sub-button', figure=='TwoLines' ? 'two-lines' : figure.toLowerCase()]"
                      @click.prevent="useFigure(figure)">
              </button>
            </li>
          </ul>
        </li>
        <li class="room-doc-share-palette-item">
          <div class="room-doc-share-palette-button-wrapper">
            <button class="room-doc-share-palette-button text" :class="{ selected : selectedTab == 'Text' }"
                    v-tooltip.bottom="$t('doc.palette.text')" @click.prevent="useText(20)">
            </button>
          </div>
          <ul class="room-doc-share-palette-sub-list">
            <li class="room-doc-share-palette-sub-item">
              <button class="room-doc-share-palette-sub-button text xs" @click.prevent="useText(20)"></button>
            </li>
            <li class="room-doc-share-palette-sub-item">
              <button class="room-doc-share-palette-sub-button text s" @click.prevent="useText(30)"></button>
            </li>
            <li class="room-doc-share-palette-sub-item">
              <button class="room-doc-share-palette-sub-button text m" @click.prevent="useText(40)"></button>
            </li>
            <li class="room-doc-share-palette-sub-item">
              <button class="room-doc-share-palette-sub-button text l" @click.prevent="useText(50)"></button>
            </li>
            <li class="room-doc-share-palette-sub-item">
              <button class="room-doc-share-palette-sub-button text xl" @click.prevent="useText(60)"></button>
            </li>
          </ul>
        </li>
        <li class="room-doc-share-palette-item">
          <div class="room-doc-share-palette-button-wrapper">
            <button class="room-doc-share-palette-button eraser" :class="{ selected : selectedTab == 'Eraser' }"
                    v-tooltip.bottom="$t('doc.palette.eraser')" @click.prevent="useEraser">
            </button>
          </div>
          <ul class="room-doc-share-palette-sub-list">
            <li class="room-doc-share-palette-sub-item">
              <button class="room-doc-share-palette-sub-button eraser"
                      @click.prevent="clearCanvas"></button>
            </li>
          </ul>
        </li>
        <li class="room-doc-share-palette-item">
          <div class="room-doc-share-palette-button-wrapper">
            <button class="room-doc-share-palette-button zoom"
                    v-tooltip.bottom="$t('doc.palette.zoom')">
            </button>
          </div>
          <ul class="room-doc-share-palette-sub-list">
            <li class="room-doc-share-palette-sub-item">
              <button class="room-doc-share-palette-sub-button zoom in"
              @click.prevent="zoom(0.1)">
              </button>
            </li>
            <li class="room-doc-share-palette-sub-item">
              <button class="room-doc-share-palette-sub-button zoom out"
              @click.prevent="zoom(-0.1)">
              </button>
            </li>
            <li class="room-doc-share-palette-sub-item">
              <button class="room-doc-share-palette-sub-button zoom fit"
              @click.prevent="zoomFit">
              </button>
            </li>
            <li class="room-doc-share-palette-sub-item">
              <button class="room-doc-share-palette-sub-button zoom origin"
              @click.prevent="zoomOri">
              </button>
            </li>
          </ul>
        </li>
        <li class="room-doc-share-palette-item">
          <div class="room-doc-share-palette-button-wrapper">
            <button class="room-doc-share-palette-button move"
                    :class="{ selected : selectedTab === 'Move' }"
                    v-tooltip.bottom="$t('doc.palette.move')" @click.prevent="useMove">
            </button>
          </div>
        </li>
        <div class="room-doc-share-palette-divider"></div>
        <li class="room-doc-share-palette-item">
          <div class="room-doc-share-palette-button-wrapper">
            <button class="room-doc-share-palette-button color" :style="{ '--selectedColor' : selectedColor }" v-tooltip.bottom="$t('doc.palette.color')"></button>
          </div>
          <ul class="room-doc-share-palette-sub-list color">
            <li v-for="color in $parent.$refs.csCanvas.colorList" :key="color" class="room-doc-share-palette-sub-item">
              <button class="room-doc-share-palette-sub-button color"
              :class="[{ selected : selectedColor == color }, '_'+color.substr(1).toLowerCase()]"
              @click.prevent="changeColor(color)"><span :style="{ 'background-color': color}" />
              </button>
            </li>
          </ul>
        </li>
        <li class="room-doc-share-palette-item">
          <div class="room-doc-share-palette-button-wrapper">
            <button class="room-doc-share-palette-button thickness" v-tooltip.bottom="$t('doc.palette.thickness')"></button>
          </div>
          <ul class="room-doc-share-palette-sub-list">
            <li class="room-doc-share-palette-sub-item">
              <button class="room-doc-share-palette-sub-button thickness minus"
                      @click.stop="$parent.$refs.csCanvas.strokeWidth = Math.max(parseInt($parent.$refs.csCanvas.strokeWidth, 10) - 10, 1)" />
            </li>
            <li v-if="$parent.$refs.csCanvas.csCanvas?.getCurrentToolkit().style.lineWidth"
                class="room-doc-share-palette-sub-item"
            >
              <div class="room-doc-share-palette-sub-button thickness range">
                  <input type="range" min="1" max="70"
                         :value="selectedStrokeWidth"
                         @input="changeStrokeWidth"/>
              </div>
            </li>
            <li class="room-doc-share-palette-sub-item">
              <button class="room-doc-share-palette-sub-button thickness plus"
                      @click.stop="$parent.$refs.csCanvas.strokeWidth = Math.min(parseInt($parent.$refs.csCanvas.strokeWidth, 10) + 10, 70)" />
            </li>
          </ul>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: 'RoomDocPalette',
  data(){
    return{
      selectedTab: '',
      selectedColor: '',
      selectedStrokeWidth: 0,
      figureList: ['Rectangle', 'Circle', 'Triangle', 'Pentagon', 'Star', 'Diamond', 'Line', 'TwoLines']
    }
  },
  mounted(){
    this.setDefaultValue()
  },
  methods: {
    setDefaultValue() {
      this.selectedColor = this.$parent.$refs.csCanvas.csCanvas.getCurrentToolkit().style.strokeStyle;
      this.selectedTab = this.$parent.$refs.csCanvas.csCanvas.getCurrentToolkit().type;
      this.selectedStrokeWidth = this.$parent.$refs.csCanvas.csCanvas.getCurrentToolkit().style.lineWidth;
    },
    useLaserPointer() {
      this.$parent.$refs.csCanvas.setToolkit('LaserPointer');
      this.selectedTab = 'LaserPointer'
    },
    usePencil() {
      this.$parent.$refs.csCanvas.setToolkit('Pencil');
      this.selectedTab = 'Pencil'
    },
    useHighlighter() {
      this.$parent.$refs.csCanvas.setToolkit('Highlighter');
      this.selectedTab = 'Highlighter'
    },
    useFigure(figure) {
      this.$parent.$refs.csCanvas.setToolkit(figure);
      this.selectedTab = figure
    },
    useText(fontSize) {
      this.$parent.$refs.csCanvas.setToolkit('Text', fontSize);
      this.selectedTab = 'Text'
    },
    useEraser() {
      this.$parent.$refs.csCanvas.setToolkit('Eraser', event);
      this.selectedTab = 'Eraser'
    },
    clearCanvas() {
      this.$parent.$refs.csCanvas.clearCanvas();
    },
    zoom(scale) {
      this.$parent.$refs.csCanvas.zoom(scale);
    },
    zoomFit() {
      this.$parent.$refs.csCanvas.zoomFit();
    },
    zoomOri() {
      this.$parent.$refs.csCanvas.zoomOri();
    },
    useMove() {
      this.$parent.$refs.csCanvas.setToolkit('Move');
      this.selectedTab = 'Move'
    },
    changeColor(color) {
      this.$parent.$refs.csCanvas.changeColor(color);
      this.selectedColor = this.$parent.$refs.csCanvas.color
    },
    changeStrokeWidth() {
      this.$parent.$refs.csCanvas.changeStrokeWidth(event.target.value);
    }
  },
}
</script>

<style lang="scss" scoped >
.room-doc-share-palette-component {}
.room-doc-share-palette {}
.room-doc-share-palette-list {}
.room-doc-share-palette-item {
  height: 50px;
  position: relative;
  &:hover {
    .room-doc-share-palette-sub-list {
      opacity: 1;
      visibility: visible;
    }
  }
}
.room-doc-share-palette-button-wrapper {
  height: 100%;
}
.room-doc-share-palette-button {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  transition: 0.1s ease-out;
  &::before {
    content: '';
    width: 18px;
    height: 100%;
    display: block;
    filter: brightness(0);
    opacity: 0.6;
    transition: 0.1s ease-out;
  }
  &.laser-pointer {
    &::before {
      background: url('~@/assets/images/palette/pointer_blue.svg') no-repeat center / 100% auto;
    }
  }
  &.pencil {
    &::before {
      background: url('~@/assets/images/palette/pen_blue.svg') no-repeat center / 100% auto;
    }
  }
  &.highlighter {
    &::before {
      background: url('~@/assets/images/palette/highlighter_blue.svg') no-repeat center / 100% auto;
    }
  }
  &.figures {
    &::before {
      background: url('~@/assets/images/palette/figures_blue.svg') no-repeat center / 100% auto;
    }
  }
  &.text {
    &::before {
      background: url('~@/assets/images/palette/text_blue.svg') no-repeat center / 100% auto;
    }
  }
  &.eraser {
    &::before {
      background: url('~@/assets/images/palette/eraser_blue.svg') no-repeat center / 100% auto;
    }
  }
  &.zoom {
    &::before {
      background: url('~@/assets/images/palette/zoom_blue.svg') no-repeat center / 100% auto;
    }
  }
  &.move {
    &::before {
      background: url('~@/assets/images/palette/hand_blue.svg') no-repeat center / 100% auto;
    }
  }
  &.thickness {
    &::before {
      background: url('~@/assets/images/palette/thickness_blue.svg') no-repeat center / 100% auto;
    }
  }
  &.color {
    &::before {
      width: 18px;
      height: 18px;
      border-radius: 50%;
      display: block;
      background-color: var(--selectedColor);
      filter: brightness(1);
      opacity: 1;
    }
  }
  &:hover, &.selected {
    background-color: #fff !important;
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
    &::before {
      filter: brightness(1);
      opacity: 1;
    }
  }
}
.room-doc-share-palette-sub-list {
  width: max-content;
  max-width: 200px;
  background-color: #f4f4f4;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.3);
  display: flex;
  flex-wrap: wrap;
  position: absolute;
  top: 0;
  right: 100%;
  opacity: 0;
  visibility: hidden;
  transition: 0.1s ease-out;
  &.color {
    padding: 6px;
    box-sizing: initial;
  }
}
.room-doc-share-palette-sub-item {}
.room-doc-share-palette-sub-button {
  width: 50px;
  height: 50px;
  opacity: 0.6;
  transition: 0.1s ease-out;
  &.rectangle {
    background: url('~@/assets/images/palette/rectangle.svg') no-repeat center / 18px auto;
  }
  &.circle {
    background: url('~@/assets/images/palette/circle.svg') no-repeat center / 18px auto;
  }
  &.triangle {
    background: url('~@/assets/images/palette/triangle.svg') no-repeat center / 18px auto;
  }
  &.pentagon {
    background: url('~@/assets/images/palette/pentagon.svg') no-repeat center / 18px auto;
  }
  &.star {
    background: url('~@/assets/images/palette/star.svg') no-repeat center / 18px auto;
  }
  &.diamond {
    background: url('~@/assets/images/palette/diamond.svg') no-repeat center / 18px auto;
  }
  &.line {
    background: url('~@/assets/images/palette/line.svg') no-repeat center / 18px auto;
  }
  &.two-lines {
    background: url('~@/assets/images/palette/twolines.svg') no-repeat center / 18px auto;
  }
  &.text {
    width: 40px;
    background: url('~@/assets/images/palette/text.svg') no-repeat center / 18px auto;
    &.xs {
      background-size: 10px auto;
    }
    &.s {
      background-size: 14px auto;
    }
    &.m {
      background-size: 18px auto;
    }
    &.l {
      background-size: 22px auto;
    }
    &.xl {
      background-size: 26px auto;
    }
  }
  &.eraser {
    background: url('~@/assets/images/palette/all_eraser.svg') no-repeat center / 24px auto;
  }
  &.zoom {
    width: 40px;
    &.in {
      background: url('~@/assets/images/palette/plus.svg') no-repeat center / 18px auto;
    }
    &.out {
      background: url('~@/assets/images/palette/minus.svg') no-repeat center / 18px auto;
    }
    &.fit {
      background: url('~@/assets/images/palette/zoom_fit.svg') no-repeat center / 24px auto;
    }
    &.origin {
      background: url('~@/assets/images/palette/zoom_ori.svg') no-repeat center / 24px auto;
    }
  }
  &.color {
    width: 40px;
    height: 40px;
    display: flex;
    justify-content: center;
    align-items: center;
    opacity: 1;
    span {
      width: 20px;
      height: 20px;
      border-radius: 100%;
      display: block;
      border: 0 solid #fff;
      pointer-events: none;
      transition: 0.1s ease-out;
    }
    &:hover, &.selected {
      background-color: transparent !important;
      box-shadow: none;
      span {
        border: 2px solid #fff;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);
      }
    }
  }
  &.thickness {
    width: 40px;
    &.minus {
      background: url('~@/assets/images/palette/minus.svg') no-repeat center / 12px auto;
    }
    &.range {
      width: 80px;
      padding: 0 4px;
      display: flex;
      align-items: center;
      input {
        width: 100%;
      }
    }
    &.plus {
      background: url('~@/assets/images/palette/plus.svg') no-repeat center / 12px auto;
    }
  }
  &:hover {
    background-color: #fff !important;
    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.1);
    opacity: 1;
  }
}
.room-doc-share-palette-divider {
  padding: 0 8px;
  display: flex;
  justify-content: center;
  &::before {
    content: '';
    width: 100%;
    height: 1px;
    margin: 8px 0;
    border-top: 1px solid #dadada;
    border-bottom: 1px solid #fff;
    box-sizing: border-box;
    display: block;
  }
}

[grm-device-mobile]{
  [data-open-extend-menu] {
    .room-doc-share-palette-sub-list {
      right: 350px;
    }
  }
  .room-doc-share-palette-component {
    height: 100%;
  }
  .room-doc-share-palette{
    height: 100%;
    overflow-y: auto;
  }
  .room-doc-share-palette-sub-list {
    width: 50px;
    padding: 0;
    flex-direction: column;
    flex-wrap: nowrap;
    position: fixed;
    top: 50px;
    right: 50px;
    bottom: 0;
    overflow-y: auto;
  }
  .room-doc-share-palette-sub-item {
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .room-doc-share-palette-sub-button {
    width: 50px !important;
    height: 50px;
  }
}
</style>